import $ from 'jquery'

$('#leadershipTabs a.nav-link').on('click', function (e) {
    if (!$(this).hasClass('no-filters')) {
        $('#team-filters').removeClass('d-none');
        if($(this).hasClass('populated-filters')) {
            return;
        }
        var activeTabId = $(this).data('bs-target');
        var roles = [];
        var committees = [];
        var teamPosts = $(activeTabId).find('.team-post');

        teamPosts.each(function () {
            var $teamMember = $(this);
            
            $teamMember.find('.term-item[data-committee]').each(function() {
                var committee_id = $(this).data('committee');
                var committee_label = $(this).data('committee-label');
                if (committee_id && committee_label) {
                    committees.push({ id: committee_id, label: committee_label });
                }
            });
        });

        committees = committees.filter((committee, index, self) =>
            index === self.findIndex((c) => (
                c.id === committee.id && c.label === committee.label
            ))
        );

        // Update the filter dropdowns with the roles and committees
        var $committeeFilter = $('#filterCommittee');
        var committeeOrder = $committeeFilter.data('committee-order');

        // Sort the committees array based on the order array
        committees = committees.sort((a, b) => {
            return committeeOrder.indexOf(a.id) - committeeOrder.indexOf(b.id);
        });

        // Remove all options except the first one
        $committeeFilter.find('option:not(:first)').remove();

        // Populate committee filter if there are committees, otherwise hide the select box
        if (committees.length > 0) {
            committees.forEach(function (committee) {
                $committeeFilter.append('<option value="' + committee.id + '">' + committee.label + '</option>');
            });
            $committeeFilter.show(); // Ensure the select box is shown if it has options
        } else {
            $committeeFilter.hide(); // Hide the select box if there are no committees
        }

        $(this).addClass('populated-filters');


    } else {
        $('#team-filters').addClass('d-none');
    }
});

$('#filterCommittee, #filterRole').on('change', function() {
    var committeeValue = $('#filterCommittee').val();
    var activeTabId = $('#leadershipTabs a.nav-link.active').data('bs-target');

    if (committeeValue !== 'all' && !isNaN(committeeValue)) {
        committeeValue = parseInt(committeeValue);
    }

    $('.committee-label').addClass('d-none');

    var teamPosts = $(activeTabId).find('.team-post');

    teamPosts.hide(); // Hide all team members

    if (committeeValue === 'all') {
        teamPosts.show(); // Show all team members
    } else {
        teamPosts.each(function() {
            var $teamMember = $(this);
            var memberCommittees = $teamMember.find('.term-item[data-committee]').map(function() {
                return $(this).data('committee');
            }).get();

            var showMember = false;

            if (memberCommittees.includes(committeeValue)) {
                showMember = true;
            }

            if (showMember) {
                console.log('showMember', showMember);
                $teamMember.show(); // Show team member if criteria matches
                var $committeeTeamMember = $teamMember.find('.card-desc .committee-label');
                if ($committeeTeamMember.length > 0) {
                    var committeeTeamMemberValue = $committeeTeamMember.data('committee-id');
                    if (committeeTeamMemberValue === committeeValue) {
                        $committeeTeamMember.removeClass('d-none');
                    }
                }
            }
        });
    }
});